import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui";
import { AlertTriangle } from "lucide-react";

export const ErrorCard = ({message}:{message?:string}) => {
  const supportEmail = process.env.APP_SUPPORT_EMAIL || "";

  return (
    <Card className="mb-6">
      <CardHeader>
        <div className="flex items-center flex-row">
          <AlertTriangle className="h-5 w-5 text-red-500 mr-2" />
          <CardTitle>Error</CardTitle>
        </div>
        <CardDescription>An error occurred while processing your request.</CardDescription>
      </CardHeader>
      <CardContent>
      <p className="mt-2 text-gray-600">Please contact our support:<br /> 
      <a className="font-bold text-blue-600" href={`mailto:${supportEmail}&subject=Error on jobcompass.ai&body=${message}`}>{supportEmail}</a>
      </p>
      { message && 
      <div className="mt-5"><p className="text-red-500 font-bold">Error Message</p>
      <p className="mt-2 bg-red-100 p-4 border-red-500 outline-2 text-black">{message}</p>
      </div> }

        </CardContent>
    </Card>
  );
}